import Vue from 'vue'
import { mapState } from 'vuex'
import CustomerInfo from './CustomerInfo/CustomerInfo.vue'
import GeneralInfo from './GeneralInfo/GeneralInfo.vue'
import SocialMedia from '@/partials/SocialMediaSection/SocialMediaSection.vue'
import { getMyCustomerProfile } from '@/api/users'
import { DASHBOARD, PROFILE_SETTINGS } from '@/constants/routes'
import rolebleMixin from '@/mixins/rolebleMixin'
import GeneralInfoModel from '@/models-ts/user/profiles/cutomer/GeneralInfo'
import IndividualInfo from '@/models-ts/user/profiles/cutomer/IndividualInfo'
import MyCustomerProfile from '@/models-ts/user/profiles/cutomer/MyCustomerProfile'
import ActionsSection from '../ActionsSection/ActionsSection.vue'
import AvatarSection from '../AvatarSection/AvatarSection.vue'

export default Vue.extend<any, any, any, any>({
  mixins: [rolebleMixin],
  components: {
    AvatarSection,
    ActionsSection,
    CustomerInfo,
    GeneralInfo,
    SocialMedia,
  },
  data() {
    return {
      DASHBOARD,
      PROFILE_SETTINGS,
      profile: null,
    }
  },
  computed: {
    ...mapState('user', {
      userInfoLoaded: (state: any) => state.profile.isLoaded,
      userInfoLoading: (state: any) => state.profile.isLoading,
    }),
  },
  watch: {
    userInfoLoaded: {
      async handler() {
        if (this.activeRole) {
          this.profile = MyCustomerProfile.fromServer(await getMyCustomerProfile())
        }
      },
      immediate: true,
    },
  },
  methods: {
    onGeneralInfoUpdate(info: GeneralInfoModel) {
      this.profile.generalInfo = info
    },
    onCustomerInfoUpdate(info: MyCustomerProfile) {
      this.profile = info
    },
  },
})
